import { ArrowRight, Check, Minus, Plus } from "lucide-react";

export const Icons = {
  arrowRight: ArrowRight,
  check: Check,
  plus: Plus,
  minus: Minus,
};
